import React from 'react';
import UserProfile from './UserProfile';
import DocumentStatus from './DocumentStatus';
import GroupManagement from './GroupManagement';
import InterviewChatbot from './InterviewChatbot';
import OnboardingCard from './OnboardingCard';
import styles from '../../styles/Dashboard/Dashboard.module.css';


const Dashboard = ({ setActiveTab, setHighlightedSidebarItem }) => {
  return (
    <div className={styles.dashboard}>
	  <OnboardingCard 
        setActiveView={setActiveTab} 
        setHighlightedSidebarItem={setHighlightedSidebarItem}
      />
	  
	  Detailed Dashboard Coming Soon
      {/*<UserProfile />
      <DocumentStatus />
      <GroupManagement />
      <InterviewChatbot />*/}
    </div>
  );
};

export default Dashboard;
